import React from 'react';
import styled from 'styled-components';

const StyledSubNavWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.bgColor};
`

export default StyledSubNavWrapper;